// Copyright (c) 2016 Deere & Company

import 'react-datepicker/dist/react-datepicker.css';
import './stolen-status-details.scss';
import React, {PropTypes} from 'react';
import AgencyName from '../input-fields/agency-name';
import City from '../input-fields/city';
import CountriesDropdown from '../dropdowns/countries-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import ReportNumber from '../input-fields/report-number';
import StatesInCountryDropdown from '../dropdowns/states-in-country-dropdown';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import StolenDate from '../input-fields/stolen-date';

const StolenStatusDetails = props =>
    <section className='stolen-status-details'>
        <div className='status-change-item'>
            <AgencyName
                onItemChange={props.onItemChange}
                statusChangeRequest={props.statusChangeRequest}
            />
        </div>
        <div className='status-change-item'>
            <City
                onItemChange={props.onItemChange}
                statusChangeRequest={props.statusChangeRequest}
            />
        </div>
        <div className='status-change-item'>
            <CountriesDropdown
                countries={props.countries}
                onItemChange={props.onItemChange}
                statusChangeRequest={props.statusChangeRequest}
            />
        </div>
        <div className='status-change-item'>
            <StatesInCountryDropdown
                onItemChange={props.onItemChange}
                statesInCountry={props.statesInCountry}
            />
        </div>
        <div className='status-change-item'>
            <StolenDate
                onItemChange={props.onItemChange}
                statusChangeRequest={props.statusChangeRequest}
            />
        </div>
        <div className='status-change-item'>
            <ReportNumber
                onItemChange={props.onItemChange}
                statusChangeRequest={props.statusChangeRequest}
            />
        </div>
    </section>;

StolenStatusDetails.displayName = 'StatusChangeProductInfo';
StolenStatusDetails.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onItemChange: PropTypes.func.isRequired,
    statesInCountry: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default StolenStatusDetails;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/additional-fields-views/stolen-status-details.js